// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  sessionId: __t.u64(),
  messageId: __t.u64(),
  sentenceIndex: __t.u32(),
  totalSentences: __t.u32(),
  mimeType: __t.string(),
  sampleRate: __t.u32(),
  audioBytes: __t.byteArray(),
  durationMs: __t.u32(),
  isFinal: __t.bool(),
  downloadUrl: __t.string(),
};
